import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Select from "../../form/Select";
import ColorPicker from "../../form/ColorPicker";
import Figures from "../../form/Figures";

class ShopForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                    <div className="col-sm-3">
                        <Select
                            {...this.props.getFieldProps("shop_group_id")}
                            name="shop_group_id"
                            optionname="shop_group"
                            storeType="local"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.shop_group_id}
                            label="Típus"
                        />
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <ColorPicker
                                name="color"
                                value={this.props.values.color}
                                isClearable={true}
                                label="Szín"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("color")}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="email"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Email"
                        />
                    </div>
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="phone"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Telefon"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Figures name="images" label="Képek" component="location" componentId={this.props.values.location_id} />
                    </div>
                </div>
                <ComponentField
                    getFieldProps={this.props.getFieldProps}
                    componentConfig={this.props.componentConfig}
                    name="url"
                    values={this.props.values}
                    setFieldValue={this.props.setFieldValue}
                    label="Url"
                />
            </form>
        );
    }
}

export default createForm(ShopForm);
